let privateRoutes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import(  '../views/Dashboard.vue')
    }
];
import UtilitiesRoutes from "../../../vendor/hitech-informatica/utilities/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(UtilitiesRoutes);
import DataBasesRoutes from "../../../vendor/hitech-informatica/data-bases-rmc/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(DataBasesRoutes);
import ForumRoutes from "../../../vendor/hitech-informatica/forum/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(ForumRoutes);
import RolesRoutes from "../../../vendor/hitech-informatica/roles/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(RolesRoutes);
import ProfessionalsRoutes from "../../../vendor/hitech-informatica/professionals/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(ProfessionalsRoutes);
import AgreementsRoutes from "../../../vendor/hitech-informatica/agreements/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(AgreementsRoutes);
import AdditionalInformationRoutes from '../../../vendor/hitech-informatica/additional-information/resources/js/routes/routes';
privateRoutes = privateRoutes.concat(AdditionalInformationRoutes);
import LibraryRoutes from "../../../vendor/hitech-informatica/library/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(LibraryRoutes);
import VideosRoutes from "../../../vendor/hitech-informatica/videos/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(VideosRoutes);
import CircularsRoutes from "../../../vendor/hitech-informatica/circulars/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(CircularsRoutes);
import BlogRoutes from "../../../vendor/hitech-informatica/blog-ms/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(BlogRoutes);
import ValueAddedServicesRoutes from "../../../vendor/hitech-informatica/value-added-services/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(ValueAddedServicesRoutes);
import SoftwareServicesRoutes from "../../../vendor/hitech-informatica/software-services/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(SoftwareServicesRoutes);
import SpecificServicesRoutes from "../../../vendor/hitech-informatica/specific-services/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(SpecificServicesRoutes);
import InternalSupportRoutes from '../../../vendor/hitech-informatica/internal-support/resources/js/routes/routes';
privateRoutes = privateRoutes.concat(InternalSupportRoutes);           
import ProcessManagementRoutes from "../../../vendor/hitech-informatica/process-management/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(ProcessManagementRoutes)
import ConveniosCCAARoutes from '../../../vendor/hitech-informatica/convenios-ccaa/resources/js/routes/routes';
privateRoutes = privateRoutes.concat(ConveniosCCAARoutes);
import OfficesRoutes from "../../../vendor/hitech-informatica/offices/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(OfficesRoutes);
import InternalCommunicationsRoutes from "../../../vendor/hitech-informatica/internal-communications/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(InternalCommunicationsRoutes);
import EntrepreneurshipsRoutes from "../../../vendor/hitech-informatica/entrepreneurships/resources/js/routes/routes";
privateRoutes = privateRoutes.concat(EntrepreneurshipsRoutes);
//addRouter
export default privateRoutes;